<template>
  <div class="outsideShow">
    <el-card class="largeScreenCard">
      <div class="cardTitle">数据展示大屏</div>
      <!-- <el-table :data="tableData" :row-class-name="tableRowClassName">
        <el-table-column type="index" align="center" :index="indexMethod" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <el-table-column label="名称">
          <template slot-scope="scope">{{scope.row.name}}</template>
        </el-table-column>
        <el-table-column label="地址">
          <template slot-scope="scope">
            <a :href="scope.row.url" target="_blank" rel="noopener noreferrer">{{ scope.row.url }}</a>
          </template>
        </el-table-column>
        <el-table-column label="说明">
          <template slot-scope="scope">{{scope.row.remark}}</template>
        </el-table-column>
      </el-table> -->
      <div class="cardInfoBox">
        <div class="cardList" v-for="(item,index) in tableDataDp" :key="index" @click="goLargeScreen(item.url)">
          <div class="cardItem">
            <p>{{item.name}}</p>
            <img class="gifImg" :src="item.img" alt="">
          </div>
          <div class="cardRemark" v-html="item.remark"></div>
        </div>
      </div>
    </el-card>
    <el-card class="biCard">
      <div class="cardTitle">数据分析BI</div>
      <el-table :data="tableDataBi" :row-class-name="tableRowClassName">
        <el-table-column type="index" align="center" :index="indexMethod" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <el-table-column label="名称" width="300">
          <template slot-scope="scope">{{scope.row.name}}</template>
        </el-table-column>
        <el-table-column label="地址">
          <template slot-scope="scope">
            <a :href="scope.row.url" target="_blank" rel="noopener noreferrer">{{ scope.row.url }}</a>
          </template>
        </el-table-column>
        <el-table-column label="说明" width="400">
          <template slot-scope="scope">{{scope.row.remark}}</template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:outsideShow
   *@Description:外拓演示
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2025-01-02
   */
  export default {
    name: '/manage/main.outsideShow',
    data() {
      return {
        pageNo: 1,
        pageSize: 10,
        tableData: [{
          'name': '格林豪森服务实时大屏数据',
          'remark': '格林豪森服务实时大屏数据，可查看集团下所有项目的位置分布，报事工单及评价实时展示，业主APP绑定率，工单类型占比，满意度折线，多项目不同维度排名等综合信息。',
          'url': 'https://b.datav.run/share/3fe519de00df0a3eef83a11d7e1f1d50'
        }, {
          'name': '格林玫瑰湾数字化园区',
          'remark': '格林玫瑰湾数字化园区，可查看项目基础信息展示，项目电子沙盘图，园区鹰眼实时监控，园区内智慧通行数据统计，缴费信息实时统计，GBA设备机房状态监控，园区报事实时展示。',
          'url': 'https://b.datav.run/share/page/2a264f8998d98e6d332854f1ebe9be47'
        }],
        tableDataDp: [{
          'name': '格林豪森服务实时大屏数据',
          'remark': '格林豪森服务实时大屏数据，可查看集团下所有项目的位置分布，报事工单及评价实时展示，业主APP绑定率，工单类型占比，满意度折线，多项目不同维度排名等综合信息。',
          'url': 'https://b.datav.run/share/3fe519de00df0a3eef83a11d7e1f1d50',
          'img': 'https://oss.kmyhwy.cn/2025/03/20/c461ee6b-4765-4e6a-8835-11d571656b2e.gif'
        }, {
          'name': '格林玫瑰湾数字化园区',
          'remark': '格林玫瑰湾数字化园区，可查看项目基础信息展示，项目电子沙盘图，园区鹰眼实时监控，园区内智慧通行数据统计，缴费信息实时统计，GBA设备机房状态监控，园区报事实时展示。',
          'url': 'https://b.datav.run/share/page/2a264f8998d98e6d332854f1ebe9be47',
          'img': 'https://oss.kmyhwy.cn/2025/03/20/c461ee6b-4765-4e6a-8835-11d571656b2e.gif'
        }],
        tableDataBi: [{
          'name': '格林门禁统计',
          'remark': '蓝牙门禁通行数据统计',
          'url': 'https://bi.aliyuncs.com/token3rd/dashboard/view/pc.htm?pageId=b81dc68c-b9bc-4725-9bee-e906e21593e8&accessToken=8992d4dfeccf9a70e2afd350d720a3af&dd_orientation=auto'
        }, {
          'name': '通用车场临时缴费',
          'remark': '格林缴费车场数据统计',
          'url': 'https://bi.aliyuncs.com/token3rd/dashboard/view/pc.htm?pageId=10679a8c-0570-43e6-8fff-19413584e787&accessToken=c13871b2e0cf92b7db2ecd98ed4d35b6&dd_orientation=auto'
        }, {
          'name': '资源点位数据分析',
          'remark': '各园区资源点位数据统计，可统计点位，合同，供应商',
          'url': 'https://bi.aliyuncs.com/token3rd/dashboard/view/pc.htm?pageId=4a58911e-e3ec-4966-8d91-edf365274807&accessToken=7c519379080cb3b67e29d18f4b6523af&dd_orientation=auto'
        }, {
          'name': '美邻生活家商城数据统计',
          'remark': '美邻生活家商品销售数据汇总',
          'url': 'https://bi.aliyuncs.com/token3rd/dashboard/view/pc.htm?pageId=96214218-985b-4a65-97eb-6e101f969245&accessToken=a22bca2c4a11e952c39cfaebc728d27a&dd_orientation=auto'
        }, {
          'name': '2024年项目考核指标（品质中心）',
          'remark': '品质部指标数据统计',
          'url': 'https://bi.aliyuncs.com/token3rd/dashboard/view/pc.htm?pageId=061af7fc-b1a3-4e59-984d-cca8b7a07354&accessToken=d324d9acca56565aeb9a21646860ba97&dd_orientation=auto'
        }, {
          'name': '电梯保养数据仪表盘',
          'remark': '电梯保养相关数据统计',
          'url': 'https://bi.aliyuncs.com/token3rd/dashboard/view/pc.htm?pageId=b01592a4-9cbb-4a2d-8418-ed5cb1e4bcdc&accessToken=76315471a8f639a55f0bdf45b68e08d0&dd_orientation=auto'
        }, {
          'name': 'GBA设备机房数据',
          'remark': '设备机房数据监控统计',
          'url': 'https://bi.aliyuncs.com/token3rd/dashboard/view/pc.htm?pageId=1313d526-a14b-450b-ba2a-e5c559f9008f&accessToken=e4d05de3e46202d6244fcc76d23c547a&dd_orientation=auto'
        }, {
          'name': '工单数据汇总（审阅，抽审）',
          'remark': '工单审阅抽审数据统计',
          'url': 'https://bi.aliyuncs.com/token3rd/dashboard/view/pc.htm?pageId=0b345776-a69e-4423-b845-db3822b3390f&accessTicket=13f5bbab-f7ff-4e18-9936-6ec6eedfd9bb&dd_orientation=auto'
        }, {
          'name': 'FM设备数据分析',
          'remark': '设备数量及巡检次数统计',
          'url': 'https://bi.aliyuncs.com/token3rd/dashboard/view/pc.htm?pageId=8b48f761-0b69-4754-b6a1-341d723ae43c&accessTicket=a6c3aaa5-1c09-46e0-80c9-6c3654f2fd00&dd_orientation=auto'
        }]
      }
    },
    created() {},
    methods: {
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
      // 表格斑马
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 跳转大屏
      goLargeScreen(url) {
        window.open(url)
      },
    },
  }
</script>

<style lang='scss'>
  .outsideShow {
    .cardTitle {
      font-size: 18px;
      padding-left: 10px;
      margin-left: 10px;
      margin-bottom: 30px;
      border-left: 3px solid #ff6207;
    }

    .largeScreenCard {
      background-color: aliceblue;
    }

    .biCard {
      margin-top: 50px;
      background-color: aliceblue;
    }

    .cardInfoBox {
      display: flex;
      padding: 20px;
    }

    .cardList {
      flex: 1;
      padding: 20px;
      margin-right: 40px;
      box-sizing: border-box;
      box-shadow: 1px 1px 10px #e8e8e8;
      border: 1px solid #fff;
      border-radius: 10px;
      background-color: #fff;
    }

    .cardList:nth-child(2n){
      margin-right: 0;
    }

    .cardItem {
      font-size: 24px;
      color: #00b1c3;
      text-align: center;
      margin-bottom: 10px;
    }

    .cardRemark {
      color: #666;
      padding: 0 1vw;
    }

    .gifImg {
      width: 100%;
      height: 3.5vw;
      object-fit: cover;
      object-position: center center;
    }
  }
</style>